import {
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    useDisclosure,
} from "@heroui/react";
import { TableEditIcon } from "../../utils/svgIcons";

export default function CreateCombinations({
    title,
    isOpen,
    onClose,
    children,
    confirmText = "Confirm",
    cancelText = "Cancel",
    isEdit = false
}) {
    return (
        <Modal size="3xl" isOpen={isOpen} backdrop='blur' placement='center' onClose={onClose} isDismissable={false} isKeyboardDismissDisabled={false} >
            <ModalContent>
                {(onClose) => (
                    <>
                        <ModalHeader className="flex flex-col gap-1">
                            {isEdit ? (
                                <div className="flex items-center gap-3"><TableEditIcon size={25} /> {title}</div>
                            ) : title}
                        </ModalHeader>
                        {children}
                    </>
                )}
            </ModalContent>
        </Modal>
    );
}
